angular.module 'app'
.controller 'UserAnalysisLayoutCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->
  $scope.permission = Storage.get('user_permission')
